var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"7c22ca07c325e0a517acebbb8f16e518b24e68f0"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["charlie-checkin@charlietech"]={id:"7c22ca07c325e0a517acebbb8f16e518b24e68f0"};
      